
export default function MultiActionAreaCard(props) {
    return (
        <div className="skill-card group bg-black hover:bg-white bg-opacity-25 hover:bg-opacity-100 hover:drop-shadow-2xl text-white hover:text-blue-change h-28 lg:h-32 w-auto grid grid-rows-[3.4rem_auto_1fr] place-items-center p-2 lg:p-3 rounded-xl overflow-visible inset-0 transform hover:scale-105 transition duration-300">
            <div className='skill-icon mt-2 flex h-12 w-12 items-center justify-center text-white group-hover:text-blue-change'>
                <div className="skill-icon-box flex h-10 w-10 items-center justify-center">
                    {props.icon}
                </div>
            </div>
            <div className='flex m-1 justify-center text-center'>
                <h1 className="text-sm lg:text-base font-bold leading-tight">{props.title}</h1>
            </div>
            <div className='justify-center m-1 hidden xl:flex text-center'>
                <p className='text-xs leading-tight max-h-8 overflow-hidden'>{props.text}</p>
            </div>

        </div>
    );
}
